import { create } from 'zustand';
import { StimulusContent } from '@/types';
import { stimulusService } from '@/services/stimulusService';

interface StimulusState {
  currentStimulus: StimulusContent | null;
  lastUsedTypes: StimulusContent['contentType'][];
  loading: boolean;
  
  // Actions
  fetchNextStimulus: (category?: string) => Promise<void>;
  markCurrentAsUsed: () => void;
  clearCurrent: () => void;
}

export const useStimulusStore = create<StimulusState>((set, get) => ({
  currentStimulus: null,
  lastUsedTypes: [],
  loading: false,

  fetchNextStimulus: async (category) => {
    set({ loading: true });
    try {
      const { lastUsedTypes } = get();
      
      // Evitar repetir os últimos 2 tipos usados
      const excludeTypes = lastUsedTypes.slice(0, 2);
      
      const stimulus = await stimulusService.getNextStimulus(category, excludeTypes);
      
      if (stimulus) {
        set(state => ({
          currentStimulus: stimulus,
          lastUsedTypes: [stimulus.contentType, ...state.lastUsedTypes].slice(0, 3),
          loading: false
        }));
      } else {
        set({ loading: false });
      }
    } catch (error) {
      console.error('Erro ao buscar estímulo:', error);
      set({ loading: false });
    }
  },

  markCurrentAsUsed: () => {
    const { currentStimulus } = get();
    if (currentStimulus) {
      stimulusService.markAsUsed(currentStimulus.id);
    }
  },

  clearCurrent: () => {
    set({ currentStimulus: null });
  }
}));
